import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/styles";
import React, { useContext, useRef } from "react";
import ProjectDataExportRange from "../../api/models/ProjectDataExportRange";
import CustomMenu from "../../components/Menu/CustomMenu";
import { StyledMenuItem } from "../../components/Menu/StyledMenu";
import GenericPermissionContext from "../../contexts/GenericPermissionContext";
import formatIdentifierAsString from "../../functions/formatIdentifierAsString.function";
import { tesaBlue } from "../../styles/colors";
import { DashboardActionHandler } from "./DashboardAction";

const useStyles = makeStyles({
  menuContainer: {
    display: "inline-flex",
    "& .MuiIconButton-root": {
      color: tesaBlue,
    },
  },
  progress: {
    padding: "12px",
  },
});

const EXPORT_RANGES_DESC: ProjectDataExportRange[] = ["THIS_YEAR", "ALL"];

interface DashboardActionMenuProps {
  onMenuClick: DashboardActionHandler;
  loading?: boolean;
}

function DashboardActionMenu({ onMenuClick: handleMenuClick, loading }: DashboardActionMenuProps) {
  const classes = useStyles();
  const { createHistoricalTestRequest, exportProjectData } = useContext(GenericPermissionContext);
  const customMenuRef = useRef<{ close: () => void }>(null);
  const showMenu = createHistoricalTestRequest;

  if (!showMenu) {
    return null;
  }

  return (
    <Box className={classes.menuContainer}>
      {loading ? (
        <CircularProgress classes={{ root: classes.progress }} color="secondary" size={48} />
      ) : (
        <CustomMenu ref={customMenuRef}>
          {createHistoricalTestRequest && (
            <StyledMenuItem
              onClick={(): void => {
                customMenuRef.current?.close();
                handleMenuClick({ type: "CREATE", requestConfig: { historical: true } });
              }}
            >
              <ListItemText primary="Create Historical Request" />
            </StyledMenuItem>
          )}
          {exportProjectData &&
            EXPORT_RANGES_DESC.map((range) => (
              <StyledMenuItem
                key={range}
                onClick={(): void => {
                  customMenuRef.current?.close();
                  handleMenuClick({ type: "EXPORT", range });
                }}
              >
                <ListItemText primary={`Export ${formatIdentifierAsString(range)}`} />
              </StyledMenuItem>
            ))}
        </CustomMenu>
      )}
    </Box>
  );
}

export default DashboardActionMenu;
